@if (tokens) {
  <ngx-json-viewer [json]="tokens"/>
}
